package com.example.mystybag.appCore.model.pages

import com.example.mystybag.common.resources.SR
import com.example.mystybag.core.expected.sharedString
import com.example.mystybag.core.model.HeaderRowVisualModel
import com.example.mystybag.core.model.PendingTaskVisualModel
import com.example.mystybag.sharedmodels.project.responseModels.HomeTopPickUiModel

enum class HomeViewMode {
    LIST,
    MAP
}

enum class BusinessCategory {
    ALL,
    BAKERY,
    CONFECTIONERY,
    FOOD_FOR_HOME,
    FISH_MARKET
}

data class HomePageUIState(
    val header: HeaderRowVisualModel = HeaderRowVisualModel(),
    val filters: List<String> = listOf(
        sharedString(SR.strings.collect_today),
        sharedString(SR.strings.collect_tomorrow),
        sharedString(SR.strings.vegetarian),
        sharedString(SR.strings.vegan)
    ),
    val selectedFilter      : String                    = sharedString(SR.strings.collect_today),
    val searchedMerchantLocationIds      : Set<Long>                 = emptySet(),
    // 🔍 search текст
    val searchQuery         : String                    = "",
    // List / Map
    val viewMode            : HomeViewMode              = HomeViewMode.LIST,
    val selectedCategory    : BusinessCategory          = BusinessCategory.ALL,

    // ✅ оригинални (нефилтрирани) списъци
    val allBakery           : List<HomeTopPickUiModel> = emptyList(),
    val allConfectionery    : List<HomeTopPickUiModel> = emptyList(),
    val allFoodForHome      : List<HomeTopPickUiModel> = emptyList(),
    val allFishMarket       : List<HomeTopPickUiModel> = emptyList(),
    val allMapItems         : List<HomeTopPickUiModel> = emptyList(),
    /** Списъкът allBags от API (BagCategoryLists.allBags) – използва се за мрежата при категория „All“. */
    val allBagsList         : List<HomeTopPickUiModel> = emptyList(),
    /** Един списък за показване в мрежата: при All = allBagsList (филтриран), иначе конкатенация на категориите. */
    val gridItemsForGrid    : List<HomeTopPickUiModel> = emptyList(),
    val categoryIdByLocationId: Map<Long, Long> = emptyMap(),

    // ✅ това са текущо видимите (филтрирани) списъци
    val bakery              : List<HomeTopPickUiModel> = emptyList(),
    val confectionery       : List<HomeTopPickUiModel> = emptyList(),
    val foodForHome         : List<HomeTopPickUiModel> = emptyList(),
    val fishMarket          : List<HomeTopPickUiModel> = emptyList(),
    val mapItems            : List<HomeTopPickUiModel> = emptyList(),

    val isLoading           : Boolean                   = true,
    val pendingTask         : PendingTaskVisualModel?   = null,
    val refreshing          : Boolean                   = false,
    val userLatitude        : Double?                   = null,
    val userLongitude       : Double?                   = null,
    /** Locations to show in the horizontal bottom sheet list: 1 when single pin tapped, N when cluster/multiple at same address. */
    val selectedLocationsForSheet: List<HomeTopPickUiModel> = emptyList(),
    val locationsToSelect  : List<HomeTopPickUiModel>  = emptyList(), // Locations at same address to choose from (legacy, dialog removed)
    /** Applied filter from Filter results bottom sheet (local filtering). null = no filter. */
    val appliedFilter       : FilterResultsUIState?    = null,
)
